<template>
    <z-card
        v-if="data"
        theme="contact"
        full-height
    >
        <template v-slot:content>
            <div class="card-contact">
                <div class="card-contact__body">
                    <div v-if="showImage" class="card-contact__image">
                        <img :src="imageUrl" :alt="data.name">
                    </div>
                    <div class="card-contact__info">
                        <h5 class="card-contact__name" v-html="data.name" v-if="data.name"></h5>
                        <div class="card-contact__position" v-html="data.position" v-if="data.position"></div>
                    </div>
                </div>
                <div class="card-contact__footer" v-if="isDetailShown">
                    <div
                        class="card-contact__footer-item"
                        v-if="data.phone && data.phone.length"
                    >
                        <z-link
                            class="card-contact__item black-text"
                            v-for="(phone, index) in adaptedPhone"
                            :key="`phone-${index}`"
                            :href="`tel:${phone.value}`"
                        >
                            <z-icon name="phone" width="24" height="24"></z-icon>
                            {{ phone.description }}
                        </z-link>
                    </div>
                    <div class="card-contact__footer-item" v-if="data.mobile && data.mobile.length">
                        <z-link
                            v-if="!hiddenContacts"
                            :href="`tel:${data.mobile}`"
                            theme="black"
                        >
                            <z-icon name="phone" width="24" height="24"></z-icon>
                            {{ data.mobile }}
                        </z-link>
                        <z-tooltip
                            v-else
                            icon-hidden
                            interactive
                            placement="top"
                            :content='data.mobile'
                        >
                            <z-link
                                :href="`tel:${data.mobile}`"
                                theme="black"
                            >
                                <z-icon name="phone" width="24" height="24"></z-icon>
                                <span>{{ text.call }}</span>
                            </z-link>
                        </z-tooltip>
                    </div>
                    <div class="card-contact__footer-item" v-if="data.fax && data.fax.length">
                        <z-link
                            :href="`tel:${data.fax}`"
                            theme="black"
                        >
                            <z-icon name="phone" width="24" height="24"></z-icon>
                            {{ data.fax }}
                        </z-link>
                    </div>
                    <div class="card-contact__footer-item" v-if="data.email && data.email.length">
                        <template v-if="!hiddenContacts">
                            <z-link
                                v-for="(item, index) in data.email"
                                :key="index"
                                :href="`mailto:${item}`"
                            >
                                <z-icon name="email" width="24" height="24"></z-icon>
                                {{ item }}
                            </z-link>
                        </template>
                        <template v-else>
                            <z-tooltip
                                icon-hidden
                                interactive
                                placement="top"
                                :content='item'
                                v-for="(item, index) in data.email"
                                :key="index"
                            >
                                <z-link
                                    :key="index"
                                    :href="`mailto:${item}`"
                                >
                                    <z-icon name="email" width="24" height="24"></z-icon>
                                    {{ text.sendEmail }}
                                </z-link>
                            </z-tooltip>
                        </template>
                    </div>
                    <div class="card-contact__footer-item" v-if="data['sales-geography']">
                        <span class="card-contact__item">
                            <z-icon name="globe" width="24" height="24"></z-icon>
                            {{ data['sales-geography'] }}
                        </span>
                    </div>
                    <div class="card-contact__footer-item" v-if="data.products">
                        <span class="card-contact__item">
                            <z-icon name="press-release" width="24" height="24"></z-icon>
                            {{ data.products }}
                        </span>
                    </div>
                </div>
            </div>
        </template>
    </z-card>
</template>

<script>
import { localize } from '@/utils/i18n'

export default {
    name: 'contacts-card',
    props: {
        data: Object,
        hiddenContacts: {
            type: Boolean,
            default: false
        },
        showImage: {
            type: Boolean,
            default: true
        }
    },
    data () {
        return {
            defaultImage: '/images/user-default.png',
            text: {
                address: localize({
                    ru: 'Адрес: ',
                    en: 'Address: '
                }),
                phone: localize({
                    ru: 'Телефон: ',
                    en: 'Phone: '
                }),
                mobile: localize({
                    ru: 'Моб. телефон: ',
                    en: 'Mobile: '
                }),
                email: localize({
                    ru: 'Почта: ',
                    en: 'Email: '
                }),
                'sales-geography': localize({
                    ru: 'География продаж: ',
                    en: 'Sales geography: '
                }),
                products: localize({
                    ru: 'Продукция: ',
                    en: 'products: '
                }),
                call: localize({
                    ru: 'Позвонить',
                    en: 'Call'
                }),
                sendEmail: localize({
                    ru: 'Отправить письмо',
                    en: 'Send email'
                })
            }
        }
    },
    computed: {
        imageUrl () {
            return this.data && this.data.image ? this.data.image : this.defaultImage
        },
        isDetailShown () {
            return (this.data.phone && this.data.phone.length) || this.data.mobile || this.data.email || this.data['sales-geography'] || this.data.products
        },
        adaptedPhone () {
            if (this.data.phone.length) {
                return this.data.phone.map((item) => {
                    if (typeof item === 'string') {
                        return {
                            value: item,
                            description: item
                        }
                    }
                    return item
                })
            }
        }
    }
}
</script>
